module.exports = __webpack_public_path__ + "static/media/RoomService_Meal1_Category2_Item1_Quantity1.7c55f748.png";